import * as yup from "yup";

export const ProductValidationSchema = yup.object().shape({
    name: yup.string().max(150, "Name not more than 150 Characters.").required("Name is Required"),

    category: yup
        .object()
        .shape({
            id: yup.number().required("Category is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select Category"),
    uom: yup
        .object()
        .shape({
            id: yup.number().required("UOM is Required"),
            label: yup.string(),
            name: yup.string(),
        })
        .typeError("Please select UOM"),
    description: yup.string().max(250, "Description not more than 250 characters."),
});
